export const scWalletAuth = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: '_msgSender', type: 'address' },
			{ indexed: true, internalType: 'address', name: '_authority', type: 'address' }
		],
		name: 'LogDisable',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: '_msgSender', type: 'address' },
			{ indexed: true, internalType: 'address', name: '_authority', type: 'address' }
		],
		name: 'LogEnable',
		type: 'event'
	},
	{
		inputs: [{ internalType: 'address', name: '_auth', type: 'address' }],
		name: 'disable',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'address', name: '_auth', type: 'address' }],
		name: 'enable',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'list',
		outputs: [{ internalType: 'contract IList', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'name',
		outputs: [{ internalType: 'string', name: '', type: 'string' }],
		stateMutability: 'view',
		type: 'function'
	}
];
